import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next'
import { getToken } from "../../../../utils/auth";

const ShareToFeedPopup = ({ show, handleClose, postData }) => {
  const [description, setDescription] = useState("");
    const { t, i18n } = useTranslation();
  const handleShare = async () => {
    try {
        const token = getToken();

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/post/share`,
        {
          postId: postData?._id,
          description,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(response?.data?.message || "Post shared successfully!");
      handleClose();
    } catch (error) {
      console.error("Error sharing post:", error);
      toast.error(error?.response?.data?.message || "Failed to share the post.");
    }
  };

  return (<>
  <Toaster position="top-right" reverseOrder={false}/>
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('shareToFeed')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Post Description */}
        {/* <p><strong>Original Description:</strong> {postData?.description}</p> */}
        
        {/* Editable Description */}
        <Form.Group className="mb-3">
          <Form.Label>{t('enter_description')}</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Form.Group>

        {/* Image Carousel */}
        {postData?.photos?.length > 0 && (
          <Carousel>
            {postData.photos.map((photo, index) => (
              <Carousel.Item key={index}>
                <img
                  className="d-block w-100"
                  src={photo}
                  alt={`post-photo-${index}`}
                  style={{ borderRadius: "8px" }}
                />
              </Carousel.Item>
            ))}
          </Carousel>

        )}
<p>{postData?.description}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {t('cancel')}
        </Button>
        <Button variant="primary" onClick={handleShare}>
          {t('share')}
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  );
};

export default ShareToFeedPopup;
